import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { transformResponseHandler } from "../../Utils/transformResponse";
import ApiRoutes from "../../Utils/ApiRoutes";
import { decrypt, encrypt } from "../../Utils/crypto";
import { apiEncrypted } from "../../Utils/function";

export const AnnouncementApis = createApi({
  reducerPath: "AnnouncementApis",
  baseQuery: async (args, api, extraOptions) => {
    const result = apiEncrypted(args, api, extraOptions)
    return result;   
  },  endpoints: (builder) => ({
    getAnnouncement : builder.query({
      query: ({search,limit,page,rrb_id}) => ({
        url: `${ApiRoutes.getAnnouncement}`,
        method: "GET",
        params:{
            search: search ?? "",
            limit,
            page,
        
        }
      }),
      providesTags:["getAnnouncement"],
      transformResponse: (res, meta) => transformResponseHandler(res, meta, false),
      transformErrorResponse: (error, meta) => transformResponseHandler(error,meta, true),
    }),
    addAnnouncement: builder.mutation({
        query: (body) => ({
          url: `${ApiRoutes.addAnnouncement}`,
          method: "POST",
          body: body,
        }),
        invalidatesTags:["getAnnouncement"],
        transformResponse: (res, meta) => transformResponseHandler(res, meta, true),
        transformErrorResponse: (error, meta) => transformResponseHandler(error,meta, true),
      }),
      editAdmin: builder.mutation({
        query: ({id,...data}) => ({
          url: `${ApiRoutes.editAdmin}/${id}`,
          method: "PUT",
          body: data,
        }),
        invalidatesTags:["getAnnouncement"],
        transformResponse: (res, meta) => transformResponseHandler(res, meta, true),
        transformErrorResponse: (error, meta) => transformResponseHandler(error,meta, true),
      }),
    
  }),
});

export const {useGetAnnouncementQuery,useAddAnnouncementMutation } = AnnouncementApis;

